import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';
import { Game, GameLevelData } from '@/types/session';
import RangeTools from '@/tools/RangeTools';

export const useGameStore = defineStore('game', () => {
  // Persistent state
  const games = useLocalStorage<Game[]>('game.games', []);
  const all_games = useLocalStorage<Game[]>('game.all_games', []);
  const inMission = useLocalStorage('game.inMission', false);
  const missionEnd = useLocalStorage<number | null>('game.missionEnd', null);
  const gameLevelData = useLocalStorage<GameLevelData>(
    'game.gameLevelData',
    {}
  );

  function updateGames(newGames: Game[]) {
    games.value = newGames;
    all_games.value = newGames;
  }

  function setInMission(status: boolean) {
    inMission.value = status;
  }

  function setMissionEnd(value: number | null) {
    missionEnd.value = value;
  }

  function updateGameLevelData(data: Partial<GameLevelData>) {
    gameLevelData.value = { ...gameLevelData.value, ...data };
  }

  function getStimulusDisplayInterval() {
    try {
      if (gameLevelData.value.game_settings) {
        let interval = Number(
          gameLevelData.value.game_settings.stimulus_display_interval
        );
        return interval * 1000;
      }

      throw new Error('No game settings found');
    } catch (e) {
      return 0;
    }
  }

  function getRandomLevelISI() {
    const rangeTools = new RangeTools();
    let settings = gameLevelData.value.game_settings;

    if (settings === undefined) {
      return 0;
    }

    return (
      rangeTools.getRandomIntegerInRange(
        settings?.isi_min ?? 0,
        settings?.isi_max ?? 1000
      ) * 1000
    );
  }

  return {
    // State
    games,
    all_games,
    inMission,
    missionEnd,
    gameLevelData,

    // Actions
    updateGames,
    setInMission,
    setMissionEnd,
    updateGameLevelData,
    getRandomLevelISI,
    getStimulusDisplayInterval,
  };
});
